import {
  AUTH_LOADING,
  CHECK_USER_EXIST_ERROR,
  CHECK_USER_EXIST_LOADING,
  CHECK_USER_EXIST_SUCCESS,
  DELETE_ACCOUNT_CHECK_ERROR,
  DELETE_ACCOUNT_CHECK_SUCCESS,
  DELETE_ACCOUNT_ERROR,
  DELETE_ACCOUNT_SUCCESS,
  FORBIDDEN_ACTION,
  GET_BASIC_SUCCESS,
  GOOGLE_LOGIN_ERROR,
  GOOGLE_LOGIN_LOADING,
  GOOGLE_LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  LOGOUT_ERROR,
  LOGOUT_SUCCESS,
  NEW_USER_CREATED,
  RESET_PASSWORD_ERROR,
  RESET_PASSWORD_INITIATE_ERROR,
  RESET_PASSWORD_INITIATE_SUCCESS,
  RESET_PASSWORD_SUCCESS,
  SET_AUTH_REDUCER,
  SIGNUP_ERROR,
  SIGNUP_SUCCESS,
  UNAUTHORIZED_USER,
  VERIFICATION_REQUIRED,
} from "../types/authTypes";
import {
  GET_CLIENT_INFO_ERROR,
  GET_CLIENT_INFO_SUCCESS,
} from "../types/commonTypes";

const initState = {
  accessToken: null,
  authError: null,
  authLoading: false,
  user: null,
  emailOrPhone: null,
  tempUid: null,
  uid: null,

  deleteAccount: null,
  checkAccountLoading: false,
  checkAccountSuccess: false,
  checkAccountError: false,
  checkAccountMessage: null,

  clientInfo: null,
  clientInfoMessage: null,
  resetPasswordLoading: false,
  resetPasswordSuccess: false,
  resetPasswordError: false,
  resetPasswordInitiateLoading: false,
  resetPasswordInitiateSuccess: false,
  resetPasswordInitiateError: false,
  resetPasswordInitiateMessage: null,
  verificationRequired: false,
};

const authReducer = (state = initState, action) => {
  switch (action.type) {
    case AUTH_LOADING:
    case GOOGLE_LOGIN_LOADING:
      return {
        ...state,
        authError: null,
        authLoading: true,
      };

    case LOGIN_ERROR:
    case SIGNUP_ERROR:
      return {
        ...state,
        authError: action.message
          ? "Login failed due to " + String(action.message).toLowerCase()
          : "Login Failed",
        authLoading: false,
      };

    case LOGIN_SUCCESS:
    case SIGNUP_SUCCESS:
      return {
        ...state,
        accessToken: action.payload.accessToken,
        authError: null,
        authLoading: false,
        refreshToken: action.payload.refreshToken,
        uid: action.payload.id,
        user: action.payload,
      };

    case GOOGLE_LOGIN_ERROR:
      return {
        ...state,
        authError: action.message ? String(action.message) : "Login Failed",
        authLoading: false,
      };

    case GOOGLE_LOGIN_SUCCESS:
      return {
        ...state,
        accessToken: action.payload.accessToken,
        authError: null,
        authLoading: false,
        refreshToken: action.payload.refreshToken,
        uid: action.payload.id,
        user: action.payload,
      };

    case NEW_USER_CREATED:
      return {
        ...state,
        newUserCreated: true,
        chechUserExistLoading: false,
        chechUserExistSuccess: false,
        chechUserExistError: false,
      };

    case GET_BASIC_SUCCESS:
      return {
        ...state,
        basicDetails: action.payload?.data,
      };

    case LOGOUT_ERROR:
      return {
        ...state,
        authError: action.message
          ? "Login failed due to " + String(action.message).toLowerCase()
          : "Login Failed",
        authLoading: false,
      };

    case DELETE_ACCOUNT_CHECK_SUCCESS:
      return {
        ...state,
        checkAccountLoading: false,
        checkAccountSuccess: true,
        checkAccountError: false,
        deleteAccount: action.payload,
      };

    case DELETE_ACCOUNT_CHECK_ERROR:
      return {
        ...state,
        checkAccountLoading: false,
        checkAccountSuccess: false,
        checkAccountError: true,
        checkAccountData: null,
        checkAccountMessage: action.message,
      };

    case DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        deleteAccountLoading: false,
        deleteAccountSuccess: true,
        deleteAccountError: false,
        deleteAccount: null,
      };

    case DELETE_ACCOUNT_ERROR:
      return {
        ...state,
        deleteAccountLoading: false,
        deleteAccountSuccess: false,
        deleteAccountError: true,
        deleteAccountData: null,
        checkAccountMessage: action.message,
      };
    case GET_CLIENT_INFO_SUCCESS:
      return {
        ...state,
        clientInfo: action.payload,
        clientInfoMessage: action.message,
      };
    case GET_CLIENT_INFO_ERROR:
      return {
        ...state,
        clientInfo: null,
        clientInfoMessage: action.message,
      };

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordSuccess: true,
        resetPasswordError: false,
        authError: null,
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        resetPasswordLoading: false,
        resetPasswordSuccess: false,
        resetPasswordError: true,
        resetPasswordMessage: action.message,
        authError: "error",
      };
    case RESET_PASSWORD_INITIATE_SUCCESS:
      return {
        ...state,
        resetPasswordInitiateLoading: false,
        resetPasswordInitiateSuccess: true,
        resetPasswordInitiateError: false,
      };
    case RESET_PASSWORD_INITIATE_ERROR:
      return {
        ...state,
        resetPasswordInitiateLoading: false,
        resetPasswordInitiateSuccess: false,
        resetPasswordInitiateError: true,
        resetPasswordInitiateMessage: action.message,
        authError: "error",
      };
    case VERIFICATION_REQUIRED:
      return {
        ...state,
        verificationRequired: true,
        tempUid: action.payload?.userId,
      };

    case LOGOUT_SUCCESS:
    case UNAUTHORIZED_USER:
    case FORBIDDEN_ACTION:
      return initState;

    case SET_AUTH_REDUCER:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default authReducer;
